import { DashboardPage } from './Dashboard';
import { createDashboardHandle } from './handle';

export default {
  Component: DashboardPage,
  createHandle: createDashboardHandle
};
